import * as angular from "angular"
import { compareArrays } from "./array"
import { isArray } from "./utils"

export function memoizeObject<T extends {}>(provider: () => T) {

    let current: T

    return () => {

        const next = provider()

        if (next === current) {
            return current
        }

        if (next && current && angular.equals(next, current)) {
            return current
        }

        current = next

        return current


    }

}

export function memoize<T>(config: () => { provider: () => T, dependencies: any[] }) {

    let last = {
        value: undefined as T,
        dependencies: undefined as any[]
    }

    return () => {

        const { dependencies, provider } = config()

        if (last.dependencies && (dependencies.length === last.dependencies.length)) {

            function compare(a: any, b: any) {

                if (isArray(a) && isArray(b)) {
                    return compareArrays(a, b, true)
                }

                return a === b

            }

            if (dependencies.every((a, index) => compare(a, last.dependencies[index]))) {
                return last.value
            }

        }

        last = {
            value: provider(),
            dependencies
        }

        return last.value

    }

}
